export class AxisEdgesContainer {
    get Edges() {
        return this.edges;
    }
    AddEdge(edge) {
        this.UpPoint = edge.TargetPoint;
        /*Assert.assert(!this.edges.has(edge))*/
        this.edges.add(edge);
    }
    constructor(source) {
        this.edges = new Set();
        this.Source = source;
    }
    RemoveAxis(edge) {
        /*Assert.assert(this.edges.has(edge))*/
        this.edges.delete(edge);
    }
    IsEmpty() {
        return this.edges.size === 0;
    }
}
//# sourceMappingURL=AxisEdgesContainer.js.map